/* eslint-disable react/no-render-return-value */

import * as React from "react";
import { createRoot, type Root } from "react-dom/client";
import { ErrorBoundary } from "~/lib/Bugsnag";

export default function reactRenderer<ElementType extends React.ElementType>(
  element: React.ReactElement<React.ComponentProps<ElementType>>,
  container: Element,
  root?: Root | undefined,
) {
  const reactRoot = root || createRoot(container);

  reactRoot.render(<ErrorBoundary>{element}</ErrorBoundary>);

  // allow components to re-render themselves
  // using the same root by returning it to them
  return reactRoot;
}
